import { ActivityTimeline } from "@/components/businesses/ActivityTimeline";
import { useBusinessActivity } from "@/hooks/useBusinesses";
import { Skeleton } from "@/components/ui/skeleton";

interface Props {
  businessId: string;
}

export const HistoryTab = ({ businessId }: Props) => {
  const { data, isLoading, error } = useBusinessActivity(businessId, {
    limit: 100,
  });

  if (isLoading) return <Skeleton className="h-60 w-full" />;
  if (error)
    return <p className="text-sm text-destructive">Failed to load history.</p>;

  return (
    <div className="bg-card rounded-card border border-border p-5">
      <h3 className="font-semibold mb-3">Activity history</h3>
      <ActivityTimeline entries={data?.data ?? []} />
    </div>
  );
};
